import { FC, useRef } from 'react';

import cx from 'classnames';

import Close from 'components/shared/Icon/icons/Close';
import Loading from 'components/shared/Icon/icons/Loading';
import Search from 'components/shared/Icon/icons/Search';

import Icon from '../Icon';
import Tooltip from '../Tooltip';
import { useGlobalSearchInput } from './functions';
import s from './index.module.css';
import { IGlobalSearchInputProps } from './types';

const GlobalSearchInput: FC<IGlobalSearchInputProps> = ({
  value,
  placeholder = '',
  isLoading,
  onChange,
  onClear,
  onSubmit,
}) => {
  const { handleEnterKey, handleSubmit, handleClear, clearIconClassNames, isFocused, handleFocus, handleBlur } =
    useGlobalSearchInput({ value, onSubmit, onClear });

  const inputRef = useRef<HTMLInputElement>(null);

  const open = isFocused || value;

  return (
    <div className={cx(s.mainWrapper, { [s.open]: open })} onClick={open ? undefined : () => inputRef.current?.focus()}>
      <Icon
        component={isLoading ? Loading : Search}
        spin={isLoading}
        className={s.searchIcon}
        onPointerDown={handleSubmit}
        data-tip
        data-for="searchIcon"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <div className={s.searchInputWrapper}>
        <input
          ref={inputRef}
          className={s.searchInput}
          value={value === undefined ? '' : value}
          placeholder={placeholder}
          type="text"
          onChange={(evt) => onChange(evt.target.value)}
          onKeyDown={handleEnterKey}
          size={placeholder?.length}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>
      <div className={clearIconClassNames} onPointerDown={handleClear}>
        <Icon component={Close} />
      </div>
      {open && <Tooltip id="searchIcon">Click &quot;Search&quot; icon or press &quot;Enter&quot; to search</Tooltip>}
    </div>
  );
};

export default GlobalSearchInput;
